import { useState } from 'react';
import styles from './.FilterBoxComponents.module.css';

const SavedContactListFilter = ({ lists, listsLoading, value, onChange, onRequestDelete }) => {
    const [isOpen, setIsOpen] = useState(false);

    const selectedList = value != null ? lists.find((l) => l.id === value) : null;
    const displayLabel = listsLoading
        ? 'Loading…'
        : selectedList
          ? selectedList.name || `List ${selectedList.id}`
          : 'All saved contacts';

    const handleSelect = (listId) => {
        onChange(listId);
        setIsOpen(false);
    };

    const toggleOpen = () => {
        if (listsLoading) return;
        setIsOpen(!isOpen);
    };

    return (
        <div className={styles.accordionContent}>
            <label>List</label>

            <div
                className={styles.filterInput}
                onClick={toggleOpen}
                style={{
                    cursor: listsLoading ? 'not-allowed' : 'pointer',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    opacity: listsLoading ? 0.7 : 1,
                }}
                aria-expanded={isOpen}
                aria-haspopup="listbox"
            >
                <span>{displayLabel}</span>
                <svg
                    className={styles.dropdownArrow}
                    style={{ height: '10px', marginRight: '5px' }}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 320 512"
                >
                    <path d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z" />
                </svg>
            </div>

            {isOpen && !listsLoading && (
                <ul className={styles.dropdown} role="listbox">
                    <li
                        className={styles.dropdownItem}
                        role="option"
                        aria-selected={value == null}
                        onClick={() => handleSelect(null)}
                    >
                        All saved contacts
                    </li>
                    {lists.map((list) => (
                        <li
                            key={list.id}
                            className={styles.dropdownItem}
                            role="option"
                            aria-selected={value === list.id}
                            onClick={() => handleSelect(list.id)}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    gap: '0.75rem',
                                }}
                            >
                                <span>{list.name || `List ${list.id}`}</span>
                                <button
                                    type="button"
                                    aria-label={`Delete list ${list.name || list.id}`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        onRequestDelete?.(list);
                                    }}
                                    style={{
                                        border: 'none',
                                        background: 'transparent',
                                        cursor: 'pointer',
                                        color: '#b42318',
                                        fontSize: '14px',
                                        lineHeight: '14px',
                                        padding: 0,
                                    }}
                                >
                                    ×
                                </button>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default SavedContactListFilter;
